import React, {forwardRef, useState} from 'react';
import PropTypes from 'prop-types';
import {FmlxIcon} from 'fmlx-common-ui';

import './Tube.scss';

const Tube = forwardRef(
  (
    {
      percentage,
      color,
      liquidOpacity,
      name,
      sampleVolume,
      diluentVolume,
      ratio,
      step,
      deletable,
      onDelete,
      tubeOpacity,
      samplePercentage,
      diluentColor,
      gradation,
      style,
    },
    ref,
  ) => {
    const [hover, setHover] = useState(false);

    const getStyle = () => {
      let initialStyle = {
        height: `${percentage}%`,
        opacity: liquidOpacity,
      };

      if (percentage) {
        initialStyle = {
          ...initialStyle,
          border: '1px solid white',
        };
      }

      if (gradation) {
        initialStyle = {
          ...initialStyle,
          backgroundColor: color,
        };
      } else {
        initialStyle = {
          ...initialStyle,
          backgroundImage: `linear-gradient(to bottom, ${color} ${samplePercentage}%, ${diluentColor} ${samplePercentage}% 100%)`,
        };
      }

      return initialStyle;
    };

    return (
      <div
        style={{opacity: tubeOpacity, ...style}}
        className="tube"
        ref={ref}
        onMouseOver={() => {
          if (!hover) {
            setHover(true);
          }
        }}
        onMouseLeave={() => {
          setHover(false);
        }}
      >
        {sampleVolume && (
          <div className="tube-sample-volume" title={sampleVolume}>
            <span className="tube-sample-volume-content">{sampleVolume}</span>
          </div>
        )}
        <div className="tube-top-cover" />
        <div className="tube-content">
          <div className="tube-content-bar" style={getStyle()} />
          {ratio && (
            <div className="tube-ratio">
              <span>
                <u>{1}</u>
              </span>
              <span>
                {ratio}
                {step > 1 && <sup>{step}</sup>}
              </span>
            </div>
          )}
          <span className="tube-diluent-volume">{diluentVolume}</span>
        </div>
        <span className="tube-name">{name}</span>
        {deletable && hover && (
          <div className="tube-delete" onClick={onDelete} role="presentation">
            <FmlxIcon name="Trash" size="sm" customColor="#4E4BFF" />
          </div>
        )}
      </div>
    );
  },
);

Tube.propTypes = {
  style: PropTypes.object,
  percentage: PropTypes.number,
  samplePercentage: PropTypes.number,
  color: PropTypes.string,
  diluentColor: PropTypes.string,
  liquidOpacity: PropTypes.number,
  tubeOpacity: PropTypes.number,
  name: PropTypes.string,
  sampleVolume: PropTypes.any,
  diluentVolume: PropTypes.any,
  ratio: PropTypes.any,
  step: PropTypes.any,
  deletable: PropTypes.bool,
  gradation: PropTypes.bool,
  onDelete: PropTypes.func,
};

Tube.defaultProps = {
  style: {},
  percentage: 0,
  samplePercentage: 0,
  color: '#0060FF',
  diluentColor: '#0060FF',
  liquidOpacity: 1,
  tubeOpacity: 1,
  name: '',
  sampleVolume: '',
  diluentVolume: '',
  ratio: null,
  step: null,
  deletable: false,
  gradation: true,
  onDelete: () => {},
};

export default Tube;
